import Image from '@react/shared/components/Image';
import cx from 'classnames';
import { array, bool, number, object, string } from 'prop-types';
import React from 'react';
import { assetPath } from 'sly/lib/path';
import ArticleTags from 'sly/resourceCenter/components/ArticleTags';
import { Heading } from 'sly/system';
import Link from 'sly/system/Link';

/**
 * @param {{
 *   alternativeText?: string,
 *   smallSizeOnPhone?: boolean,
 *   path?: string | null,
 *   title?: string,
 *   topic?: any,
 *   tagsList?: any[],
 *   shortDescription?: string,
 *   to?: string,
 *   className?: string,
 *   eventProps?: Record<string, any>,
 *   src?: string,
 *   customStyles?: string
 * }} props
 */
const ArticlePreview = ({
  alternativeText,
  smallSizeOnPhone,
  path,
  title,
  topic,
  tagsList,
  shortDescription,
  to,
  className,
  eventProps = {},
  src,
  customStyles = '',
}) => {
  const placeholder = assetPath('vectors/Board_and_Care.svg');
  return (
    <div
      className={cx(
        'box-border grid h-full w-full grid-rows-[max-content,1fr] overflow-hidden rounded border border-slate-lighter-90 hover:no-underline hover:shadow-[0_0.25rem_1rem_0_rgba(0,_0,_0,_0.1)]',
        smallSizeOnPhone ? 'h-full w-[17.5rem] md:w-[20.5rem]' : 'w-[20.5rem]',
        className
      )}
      data-tp-id='gen-Link-78d540e7-05bd-46db-be34-7099f7febcf1'
    >
      <Link to={to} eventProps={{ ...eventProps, text: title }}>
        <div
          className='relative h-max'
          data-tp-id='gen-div-04f87ce4-57eb-4c37-9a34-cce850b83d1e'
        >
          <div
            className={cx(
              'font-t-xsmall w-full overflow-hidden text-slate-base',
              smallSizeOnPhone ? 'h-[11.625rem] md:h-[13.625rem]' : 'h-max'
            )}
            data-tp-id='gen-div-df5a6e69-fe1e-4f48-9a2a-b9dc27313312'
          >
            <div
              className='aspect-w-3 aspect-h-2 w-full overflow-hidden'
              data-tp-id='gen-div-114ffbda-6f17-4bd0-a659-aea93e180027'
            >
              <Image
                path={path || (!src ? placeholder : null)}
                src={src}
                alt={alternativeText}
                layout='fill'
                objectFit='cover'
                sizes={
                  smallSizeOnPhone ? '(max-width: 727px) 280px, 328px' : '328px'
                }
                data-tp-id='gen-Image-1edf9436-20ca-4cb8-9c02-543f512c58d3'
              />
            </div>
          </div>
        </div>
      </Link>

      <div
        className='flex grow flex-col p-l'
        data-tp-id='gen-div-fcb46ecc-16fb-421c-b1c9-14cc2eaabafa'
      >
        <Link to={to} eventProps={{ ...eventProps, text: title }}>
          <Heading
            as='h3'
            className='font-t-m mb-m overflow-hidden text-ellipsis text-slate-base line-clamp-3'
            data-tp-id='gen-h3-079a1c94-7a4f-4315-bbfe-46757b33f2b3'
          >
            {title}
          </Heading>
          <div
            className={cx(
              smallSizeOnPhone
                ? 'max-w-[calc(17.5rem_-_3rem)] md:max-w-[calc(20.5rem_-_3rem)]'
                : 'max-w-[calc(20.5rem_-_3rem)]',
              'font-b-m dynamic-editor',
              'text-slate-base line-clamp-3',
              'md:line-clamp-4'
            )}
            data-tp-id='gen-div-5b87b1b8-c856-4ca2-91f7-756cf688890a'
            dangerouslySetInnerHTML={{ __html: shortDescription }}
          />
        </Link>

        {tagsList?.length > 0 && (
          <div className='mt-4'>
            <ArticleTags topic={topic} tagsList={tagsList} />
          </div>
        )}
      </div>
    </div>
  );
};

ArticlePreview.displayName = 'ResourceCenterArticlePreview';
ArticlePreview.propTypes = {
  smallSizeOnPhone: bool,
  path: string,
  alternativeText: string,
  title: string,
  topic: object,
  tagsList: array,
  shortDescription: string,
  to: string,
  customStyles: string,
  eventProps: object,
  topicSulgById: number,
  slug: string,
  className: string,
  src: string,
};

export default ArticlePreview;
